import React from 'react';
import { Form, Input, Select, Row, Col, Card } from 'antd';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from '@tanstack/react-router';

const { Option } = Select;

interface PlanDetailsCardProps {
  isLoadingCompanies: boolean;
  //  company: { label: string; value: number }[] | undefined;
    company: { label: string; value: number }[] | undefined;
  isLoadingCurrencies: boolean;
    currencies: { label: string; value: number; ISOCode: string | null }[] | undefined;
    isEdit: boolean;
}

const PlanDetailsCard: React.FC<PlanDetailsCardProps> = ({
  isLoadingCompanies,
  company,
    isLoadingCurrencies,
    currencies,
    isEdit
}) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();


  return (
      <Card title={t('Plan Details')}
    
      >
          <Row gutter={16}>
              <Col span={12}>
                  {/* when editing we no longer allow changing company; show disabled input instead */}
                  {isEdit ? (
                      <>
                          {/* keep the value for submission */}
                          <Form.Item name="companyId" hidden>
                              <Input />
                          </Form.Item>
                          <Form.Item name="companyName" label={t('Company Name')}>
                              <Input size="large" disabled />
                          </Form.Item>
                      </>
                  ) : (
                      <Form.Item name="companyId" label={t('Company Name')} rules={[{ required: true, message: t('Please select a company') }]} >
                          <Select placeholder={t('Select a company')} loading={isLoadingCompanies} size="large"
                              showSearch={true}
                              filterOption={(input, option) =>
                                  String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                              }
                          >
                              {company?.map(company => (
                                  <Option key={company.value} value={company.value} label={company.label}>{company.label}</Option>
                              ))}
                          </Select>
                      </Form.Item>
                  )}
              </Col>
        <Col span={12}>
                  <Form.Item name="name" label={t('Plan Name')}
                      rules={[{ required: true, message: t('Please input plan name!') },
                      {
                          pattern: /^(?!.* {2,})[A-Za-z\u0600-\u06FF0-9\-.'&(),\/ ]+$/,
                          message: t('validation.planNamePattern')
                          },
                          {
                              type: 'string',   
                              min: 5,
                              max: 200,
                              message: t('Plan name must be between 5 and 200 characters.'),
                          },
                  ]} >
            <Input size="large" />
          </Form.Item>
        </Col>
        
      </Row>
      <Row gutter={16}>
        <Col span={24}>
                  <Form.Item name="description" label={t('Description')} rules={[{ required: true, message: t('Please input description!') },
                      {
                      type: 'string',
                      max: 1000,
                          message: t('Plan Description must be 1000 characters long.'),
                      }
                      ,]} >
            <Input.TextArea size="large" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="currencyId" label={t('Currency')} rules={[{ required: true, message: t('Please select a currency!') }]} >
            <Select placeholder={t('Select a currency')} loading={isLoadingCurrencies} size="large"
              showSearch={true}
              filterOption={(input, option) =>
                String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {currencies?.map(currency => (
                <Option key={currency.value} value={currency.value} label={currency.label}>{currency.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default PlanDetailsCard;